module.exports = __webpack_public_path__ + "static/gradientOne-c92a44b09c9a5039f433dfe0eab0544f.png";